const IndicatorsAnalysis = () => import(/* webpackChunkName: "indicatorsAnalysis" */ './IndicatorsAnalysis.vue')

const index = {
  path: 'indicators/analysis',
  name: 'Indicators Analysis',
  component: IndicatorsAnalysis,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
